<template>
    <v-container fluid justify-center>
        <div class="blog-container">
           <div v-if="this.singleBlog" class="blog-details">
                <div class="blog-title mx-6">
                    <p>{{ singleBlog.title }}</p>
                </div>
                <div class="blog-publishDate mx-6">
                    <v-icon 
                        small
                        class="blog-publishDate__icon"
                    >
                        mdi-clock
                    </v-icon>
                    {{ formatDate(singleBlog.publishDate) }}
                </div>
                <div class="mx-auto blog-image" width="100%">
                    <v-img :src="singleBlog.image"></v-img>
                    <div class="pt-2 photo-desc mx-auto">
                        {{ singleBlog.photoDesc }}
                    </div>
                </div>
                <div class="pt-5 pb-3 mb-22 px-8 blog-text">
                    <p 
                        v-for="content in contents"
                        :key="content"
                        class="blog-content"
                    >
                        {{ content }}
                    </p>
                </div>
                <div v-if="this.links" class="mx-5 pb-5 pt-5 blog-links">
                    <p>
                        <a color="000" target="_blank" v-bind:href="`${singleBlog.articleLink}`">{{ singleBlog.articleName }}</a>
                    </p>
                </div>
                <v-divider class="mt-1"></v-divider>
                <v-row v-if="this.tags" class="py-8 px-8 mx-auto">
                    <h4 class="d-flex flex-row align-center tags">
                        Tags:
                        <v-btn 
                            v-for="tag in tags" 
                            class="rounded-card mx-4 font-weight-medium" 
                            :key="tag"
                            :to="'/blogsByTag/' + tag"
                        >
                            <p>{{ tag }}</p>
                        </v-btn>
                    </h4>
                </v-row>
            </div>
            <div v-else class="pt-14 mt-6 px-16">
                <v-row class="py-2">
                    Loading blog...
                </v-row>
            </div>
        </div>
    </v-container>  
  </template>
    
<script>
import axios from 'axios';
import titleMixin from '../mixins/titleMixin';

export default {
    name: 'singleBlog',
    mixins: [titleMixin],
    data: () => ({
        singleBlog: [],
        contents: [],
        tags: [],
        hostName: {
            portfolioServer: process.env.VUE_APP_PORTFOLIO_SERVER
        },
        links: null
    }),
    props: ['id'],
    mounted: async function() {
        let $vm = this;
        let reqId = { _id: $vm.id }
        await axios.get(`${this.hostName.portfolioServer}/api/blog`, { params: reqId })
        .then(response => {
            $vm.singleBlog = response.data[0]
            $vm.contents = response.data[0].content
            $vm.title = response.data[0].title
            $vm.tags = response.data[0].tags
            $vm.links = response.data[0].articleLink
        })
        .catch(function(error) {
            console.log(error) 
        })
        this.updateTitle();
    },
    watch: {
        singleBlog() {
            this.updateTitle();
        }
    },
    methods: {
        updateTitle() {
            document.title = `Darcey Grundy | ${this.singleBlog.title}`
        }
    }
}
</script>
    
<style lang="scss" scoped>
.blog-container {
    margin: 4px 50px;
    
    .blog-details {
        margin-left: auto !important;
        margin-right: auto !important;

        .blog-title {
            font-family: Bebas Neue;
            color: var(--v-tropicalIndigo-base) !important;

            p {
                font-size: 82px;
                line-height: 0.95;
                margin: 0;
            }
        }

    .blog-publishDate {
        display: flex;
        align-items: center;
        color: var(--v-tropicalIndigo-base) !important;
        font-family: Bebas Neue;
        margin-bottom: 35px;
        font-size: 24px;

        &__icon {
            color: var(--v-tropicalIndigo-base) !important;
            margin: 0 5px 0 2px;
        }
    }

    .blog-image {
        max-width: 95%;
    }

    .photo-desc {
        color: var(--v-tropicalIndigo-base) !important;
        font-family: Bebas Neue;
        letter-spacing: 5%;
        font-size: 26px;
    }

    .blog-content {
        font-family: Arial;
        font-size: 19px;
        line-height: 0.95;
    }

    .blog-links a {
        margin: 0 11px 0 11px;
        font-weight: 700;
        font-style: bold;
        color: black;
    }

        .tags {
            font-size: 16px;
            letter-spacing: 2.3px;

            .v-btn, p {
                background-color: var(--v-tropicalIndigo-base);
                margin: 0;
                font-weight: 600;
                color: white;
            }
        }
    }

    @media (width < 1000px) {
        margin: 4px;

        .blog-details {
            .blog-text {
                margin: 2px;
            }

            .blog-content {
                line-height: 1.3;
            }
        }
    }
}
</style>